module.exports = __webpack_public_path__ + "static/media/thirteen.237acc08.jpg";